// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Submission Form Container */
.submission-form-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.form-card {
  background: white;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.form-card h2 {
  color: #2d3748;
  font-size: 2rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.form-description {
  color: #718096;
  margin-bottom: 2rem;
  font-size: 1rem;
}

.form-hints {
  background-color: #ebf8ff;
  border-left: 4px solid #3182ce;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  margin-bottom: 2rem;
  color: #2d3748;
  font-size: 0.95rem;
}

.form-hints ul {
  margin: 0.5rem 0 0 0;
  padding-left: 1.25rem;
}

.form-hints li {
  margin-bottom: 0.4rem;
  line-height: 1.5;
}

.form-hints a {
  color: #3182ce;
  font-weight: 600;
}

/* Messages */
.message {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.message.error {
  background-color: #fed7d7;
  color: #c53030;
  border-left: 4px solid #c53030;
}

.message.success {
  background-color: #c6f6d5;
  color: #22543d;
  border-left: 4px solid #22543d;
}

/* Form Groups */
.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #2d3748;
  font-weight: 500;
  font-size: 0.95rem;
}

.required {
  color: #e53e3e;
}

.form-group input[type="text"],
.form-group input[type="number"],
.form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Checkbox Group */
.checkbox-group {
  background-color: #f7fafc;
  padding: 1rem;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  gap: 0.75rem;
}

.checkbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-top: 2px;
  cursor: pointer;
  accent-color: #667eea;
}

.checkbox-label span {
  flex: 1 1;
  color: #2d3748;
  line-height: 1.5;
}

/* File Upload Area */
.file-upload-area {
  border: 2px dashed #cbd5e0;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
  background-color: #f7fafc;
}

.file-upload-area.dragging {
  border-color: #667eea;
  background-color: #edf2f7;
}

.file-upload-area.has-file {
  border-color: #48bb78;
  background-color: #f0fff4;
}

.file-input {
  display: none;
}

.file-upload-label {
  cursor: pointer;
  display: block;
}

.upload-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.upload-icon {
  width: 48px;
  height: 48px;
  color: #667eea;
  margin-bottom: 0.5rem;
}

.upload-text {
  color: #4a5568;
  font-size: 1rem;
}

.upload-text strong {
  color: #667eea;
}

.upload-hint {
  color: #a0aec0;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.file-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.file-icon {
  width: 48px;
  height: 48px;
  color: #48bb78;
}

.file-name {
  color: #2d3748;
  font-weight: 500;
  word-break: break-all;
}

.file-size {
  color: #718096;
  font-size: 0.875rem;
}

/* Form Actions */
.form-actions {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}

.submit-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 1rem 3rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.submit-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-card {
    padding: 1.5rem;
  }

  .form-card h2 {
    font-size: 1.5rem;
  }

  .file-upload-area {
    padding: 1.5rem;
  }

  .upload-icon {
    width: 36px;
    height: 36px;
  }

  .submit-button {
    width: 100%;
    padding: 0.875rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .submission-form-container {
    padding: 0 10px;
  }

  .form-card {
    padding: 1rem;
  }

  .checkbox-label {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SubmissionForm.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Submission Form Container */\n.submission-form-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.form-card {\n  background: white;\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.form-card h2 {\n  color: #2d3748;\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.form-description {\n  color: #718096;\n  margin-bottom: 2rem;\n  font-size: 1rem;\n}\n\n.form-hints {\n  background-color: #ebf8ff;\n  border-left: 4px solid #3182ce;\n  border-radius: 8px;\n  padding: 1rem 1.25rem;\n  margin-bottom: 2rem;\n  color: #2d3748;\n  font-size: 0.95rem;\n}\n\n.form-hints ul {\n  margin: 0.5rem 0 0 0;\n  padding-left: 1.25rem;\n}\n\n.form-hints li {\n  margin-bottom: 0.4rem;\n  line-height: 1.5;\n}\n\n.form-hints a {\n  color: #3182ce;\n  font-weight: 600;\n}\n\n/* Messages */\n.message {\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.message.error {\n  background-color: #fed7d7;\n  color: #c53030;\n  border-left: 4px solid #c53030;\n}\n\n.message.success {\n  background-color: #c6f6d5;\n  color: #22543d;\n  border-left: 4px solid #22543d;\n}\n\n/* Form Groups */\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #2d3748;\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n.required {\n  color: #e53e3e;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"],\n.form-group textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n/* Checkbox Group */\n.checkbox-group {\n  background-color: #f7fafc;\n  padding: 1rem;\n  border-radius: 8px;\n  border: 2px solid #e2e8f0;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  gap: 0.75rem;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n  cursor: pointer;\n  accent-color: #667eea;\n}\n\n.checkbox-label span {\n  flex: 1;\n  color: #2d3748;\n  line-height: 1.5;\n}\n\n/* File Upload Area */\n.file-upload-area {\n  border: 2px dashed #cbd5e0;\n  border-radius: 12px;\n  padding: 2rem;\n  text-align: center;\n  transition: all 0.3s ease;\n  background-color: #f7fafc;\n}\n\n.file-upload-area.dragging {\n  border-color: #667eea;\n  background-color: #edf2f7;\n}\n\n.file-upload-area.has-file {\n  border-color: #48bb78;\n  background-color: #f0fff4;\n}\n\n.file-input {\n  display: none;\n}\n\n.file-upload-label {\n  cursor: pointer;\n  display: block;\n}\n\n.upload-prompt {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.upload-icon {\n  width: 48px;\n  height: 48px;\n  color: #667eea;\n  margin-bottom: 0.5rem;\n}\n\n.upload-text {\n  color: #4a5568;\n  font-size: 1rem;\n}\n\n.upload-text strong {\n  color: #667eea;\n}\n\n.upload-hint {\n  color: #a0aec0;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n}\n\n.file-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.file-icon {\n  width: 48px;\n  height: 48px;\n  color: #48bb78;\n}\n\n.file-name {\n  color: #2d3748;\n  font-weight: 500;\n  word-break: break-all;\n}\n\n.file-size {\n  color: #718096;\n  font-size: 0.875rem;\n}\n\n/* Form Actions */\n.form-actions {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: center;\n}\n\n.submit-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 1rem 3rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.submit-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .form-card {\n    padding: 1.5rem;\n  }\n\n  .form-card h2 {\n    font-size: 1.5rem;\n  }\n\n  .file-upload-area {\n    padding: 1.5rem;\n  }\n\n  .upload-icon {\n    width: 36px;\n    height: 36px;\n  }\n\n  .submit-button {\n    width: 100%;\n    padding: 0.875rem;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .submission-form-container {\n    padding: 0 10px;\n  }\n\n  .form-card {\n    padding: 1rem;\n  }\n\n  .checkbox-label {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
